import LombaBasket from "../../../../../assets/img/illustrations/basket.svg";
import LombaFutsal from "../../../../../assets/img/illustrations/football.svg";
import LombaDance from "../../../../../assets/img/illustrations/dance.svg";
import LombaSuporter from "../../../../../assets/img/illustrations/suporter.svg";
import BasketBall from "../../../../../assets/img/illustrations/basket-ball.svg";
import Ball from "../../../../../assets/img/illustrations/bola.svg";
import Dance from "../../../../../assets/img/illustrations/dance-header.svg";
import Suporter from "../../../../../assets/img/illustrations/suporter-header.svg";
import Juara1 from "../../../../../assets/img/illustrations/juara-1.svg";
import Juara2 from "../../../../../assets/img/illustrations/juara-2.svg";
import Juara3 from "../../../../../assets/img/illustrations/juara-3.svg";
import Terbaik from "../../../../../assets/img/illustrations/terbaik.svg";
import Terbanyak from "../../../../../assets/img/illustrations/terbanyak.svg";
import Terniat from "../../../../../assets/img/illustrations/terunik.svg";

const basicChampionPrice = [
  {
    title: "Juara 1",
    icon: Juara1,
  },
  {
    title: "Juara 2",
    icon: Juara2,
  },
  {
    title: "Juara 3",
    icon: Juara3,
  },
];

const suporterChampionPrice = [
  {
    title: "Terbaik",
    icon: Terbaik,
  },
  {
    title: "Terniat",
    icon: Terniat,
  },
  {
    title: "Terbanyak",
    icon: Terbanyak,
  },
];

export const cardLomba = [
  {
    id: 1,
    title: "Basket",
    img: LombaBasket,
    cardClass: "basket",
  },
  {
    id: 2,
    title: "Futsal",
    img: LombaFutsal,
    cardClass: "futsal",
  },
  {
    id: 3,
    title: "Dance",
    img: LombaDance,
    cardClass: "dance",
  },
  {
    id: 4,
    title: "Suporter",
    img: LombaSuporter,
    cardClass: "suporter",
  },
];

export const cardContentLomba = [
  {
    id: 1,
    title: "Basket",
    sectionClass: "basket-section",
    headerClass: "basket-header",
    eventGTM: "daftarSekarang_basket",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri maksimal 15 peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Setiap tim yang terpilih akan mendapatkan kompensasi / benefit pembuatan jersey / seragam tim dengan logo branding by.U.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
        "Cabang olahraga basket hanya untuk tim putra.",
        "1 sekolah hanya diperbolehkan mendaftarkan 1 tim peserta.",
      ],
      boldWord: ["tim putra"],
      footer: "",
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-basket",
    },
    iconhHeader: BasketBall,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 10 Juta" },
      { ...basicChampionPrice[1], price: "Rp 7,5 Juta" },
      { ...basicChampionPrice[2], price: "Rp 5 Juta" },
    ],
  },
  {
    id: 2,
    title: "Futsal",
    sectionClass: "futsal-section",
    headerClass: "futsal-header",
    eventGTM: "daftarSekarang_futsal",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri maksimal 15 peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Setiap tim yang terpilih akan mendapatkan kompensasi / benefit pembuatan jersey / seragam tim dengan logo branding by.U.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
        "Cabang olahraga futsal hanya untuk \ntim putra",
        "Setiap sekolah hanya diperbolehkan mendaftarkan 1 tim peserta.",
      ],
      boldWord: ["tim putra"],
      footer: "",
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-futsal",
    },
    iconhHeader: Ball,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 10 Juta" },
      { ...basicChampionPrice[1], price: "Rp 7,5 Juta" },
      { ...basicChampionPrice[2], price: "Rp 5 Juta" },
    ],
  },
  {
    id: 3,
    title: "Dance",
    sectionClass: "dance-section",
    headerClass: "dance-header",
    eventGTM: "daftarSekarang_dance",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan siswa sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri dari 5 sampai dengan 12 orang peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
      ],
      title2: "Ketentuan Dance: ",
      list2: [
        "Dance berdurasi 3-4 menit.",
        'Dance memuat lagu "Pink Venom" by Black Pink ATAU "Ice on My Baby" by Yung Bleu yang dapat dikreasikan (di-remix) dengan lagu lainnya.',
        "Konten Dance tidak memuat pornografi atau menyinggung SARA.",
      ],
      boldWord: [],
      footer: {
        title: "Kriteria Penilaian: ",
        list: [
          "Keindahan gerakan",
          "Kreativitas gerak",
          "Detail gerakan",
          "Kostum",
          "Kesesuaian gerak dengan musik",
          "Ekspresi",
        ],
      },
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-dance",
    },
    iconhHeader: Dance,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 2,5 Juta" },
      { ...basicChampionPrice[1], price: "Rp 1,75 Juta" },
      { ...basicChampionPrice[2], price: "Rp 1 Juta" },
    ],
  },
  {
    id: 4,
    title: "Suporter",
    sectionClass: "suporter-section",
    headerClass: "suporter-header",
    eventGTM: "daftarSekarang_supporter",
    description: {
      title: "Persyaratan: ",
      list: [
        "Setiap sekolah wajib mengirimkan suporter untuk mendukung Tim Basket atau Tim Mini Futsal dan mengikuti parade di Opening Ceremony Piala by.U",
        "Suporter wajib hadir saat tim bertanding",
        "Suporter boleh <b>menggunakan</b> alat musik & koreografi",
        "Suporter sudah memiliki Yel-yel sekolah atau Mars Sekolah",
        "Suporter memiliki konsep & menggunakan kostum parade unik.",
        "Suporter pemenang wajib hadir di setiap sesi pertandingan tim.",
      ],
      boldWord: ["suporter"],
      footer: {
        title: "Kriteria Penilaian : ",
        list: ["Kreativitas", "Kekompakan peserta", "Performance"],
      },
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-suporter-terbaik",
    },
    iconhHeader: Suporter,
    championList: [
      { ...suporterChampionPrice[0], price: "Rp 3 Juta" },
      { ...suporterChampionPrice[1], price: "Rp 2 Juta" },
      { ...suporterChampionPrice[2], price: "Rp 1 Juta" },
    ],
  },
];
